/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Grid, Title } from '@bottlebooks/gatsby-theme-base';
// import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import {
  QuickLinkButton,
  QuickLinkCard,
  QuickLinkContent,
  QuickLinkText,
  QuickLinkTitle,
  SubLink,
} from '@bottlebooks/gatsby-theme-event/src/components/LandingPage/QuickLink';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { Trans, t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import MyBookmarksAnnouncement from './MyBookmarksAnnouncement';

const max1 = '1fr';
const two = 'repeat(2, minmax(226px, 1fr))';
const max3 = 'repeat(auto-fit, minmax(304px, 1fr))';
const max4 = 'repeat(auto-fit, minmax(226px, 1fr))';

const columns = {
  default: max4,
  3: [max1, null, max4],
  4: [max1, two, null, max4],
  5: max3,
};

export default function QuickLinks({ localeConfig: _, ...rest }) {
  const link = useLink();
  const gridTemplateColumns = columns[4] || columns.default;
  return (
    <>
      <MyBookmarksAnnouncement sx={{ marginBottom: 5 }} />
      <Grid gap={2} sx={{ gridTemplateColumns }} {...rest}>
        {/* <QuickLinkCard>
        <QuickLinkContent to={link.exhibitors()}>
          <QuickLinkTitle>
            <Trans>Our Exhibitors</Trans>
          </QuickLinkTitle>
          <QuickLinkText>
            <Trans>Alle Aussteller entdecken.</Trans>
          </QuickLinkText>
          <QuickLinkButton
            to={link.exhibitors()}
            sx={{ paddingTop: link.links?.length ? 3 : 4 }}
          >
            Alle Aussteller
          </QuickLinkButton>
        </QuickLinkContent>
      </QuickLinkCard> */}
        <QuickLinkCard>
          <QuickLinkContent
            to={link.room({ slug: 'seitenhalle', floor: { slug: 'parterre' } })}
          >
            <QuickLinkTitle>
              <Trans>Exhibitors by room</Trans>
            </QuickLinkTitle>
            <QuickLinkText>
              <Trans>
                Discover all exhibitors room by room, starting at the ground
                floor.
              </Trans>
            </QuickLinkText>
            <QuickLinkButton to={link.exhibitors()} sx={{ paddingTop: 3 }}>
              <Trans>Start</Trans>
            </QuickLinkButton>
          </QuickLinkContent>
          <SubLink
            to={link.floor({ slug: 'parterre' })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Parterre</Trans>
          </SubLink>
          <SubLink
            to={link.floor({ slug: 'mezzanin' })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Mezzanin</Trans>
          </SubLink>
          <SubLink to={link.exhibitors()} sx={{ paddingLeft: [null, 3] }}>
            <Trans>All exhibitors</Trans>
          </SubLink>
        </QuickLinkCard>

        <QuickLinkCard>
          <QuickLinkContent to={link.products()}>
            <QuickLinkTitle>
              <Trans>Products</Trans>
            </QuickLinkTitle>
            <QuickLinkText>
              <Trans>Discover the presented products.</Trans>
            </QuickLinkText>
            <QuickLinkButton to={link.exhibitors()} sx={{ paddingTop: 3 }}>
              <Trans>Show all</Trans>
            </QuickLinkButton>
          </QuickLinkContent>
          <SubLink
            to={link.products({ allGrapeVarieties: 'Single variety' })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Single variety wines</Trans>
          </SubLink>
          <SubLink
            to={link.products({ allGrapeVarieties: 'Blend' })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Blends</Trans>
          </SubLink>
          <SubLink
            to={link.products({
              priceRanges: ['€€€€', '€€€€€', '€€€€€€'],
              sort: 'byProductName',
            })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Premium wines</Trans>
          </SubLink>
        </QuickLinkCard>

        <QuickLinkCard>
          <QuickLinkContent>
            <QuickLinkTitle>
              <Trans>By wine region</Trans>
            </QuickLinkTitle>
            <QuickLinkText>
              <Trans>Discover Austria's regions.</Trans>
            </QuickLinkText>
          </QuickLinkContent>
          <SubLink
            to={link.exhibitors({ origins: ['Lower Austria'] })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Lower Austria</Trans>
          </SubLink>
          <SubLink
            to={link.exhibitors({ origins: ['Vienna'] })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Vienna</Trans>
          </SubLink>
          <SubLink
            to={link.exhibitors({ origins: ['Burgenland'] })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Burgenland</Trans>
          </SubLink>
          <SubLink
            to={link.exhibitors({ origins: ['Styria'] })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Styria</Trans>
          </SubLink>
          <SubLink
            to={link.exhibitors({ origins: ['Bergland'] })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Bergland</Trans>
          </SubLink>
          <SubLink
            to={link.exhibitors({
              origins: [
                'Italy',
                'Germany',
                'Croatia',
                'Poland',
                'Slovenia',
                'Greece',
              ],
            })}
            sx={{ paddingLeft: [null, 3] }}
          >
            <Trans>Guest countries</Trans>
          </SubLink>
        </QuickLinkCard>
      </Grid>
    </>
  );
}
